import { useContext } from 'react';
import GameSelectionContext from '@domain/game.selection/game.selection.context';

export const useGame = () => {
  const context = useContext(GameSelectionContext);
  if (!context) {
    throw new Error('No GameSelectionContext available, make sure the Provider is in place and the value is actually provided');
  }
  return context;
};
